// Converts a BundledArticle (markdown authoring shape) into the runtime
// ArticleBlock[] shape used by the DB row + page renderer. Shared by:
//   - the first-boot seed (app/server/lib/seed.ts)
//   - the one-shot migration script (app/scripts/migrate-articles-to-blocks.ts)
//
// The byline is hardcoded in v1 (the only author). When per-article authors
// are needed later, the seed bundle gains an `author` field and this helper
// picks it up — no schema change required.

import type { ArticleBlock } from '@/schemas/articleBlock';
import type { BundledArticle } from '@/types/article';
import { markdownToBlocks } from './markdownToBlocks';

const DEFAULT_AUTHOR_BLOCK: ArticleBlock = {
  type: 'author',
  name: 'Chinedu Koggu',
  bio:
    'Chinedu Koggu (CK) is a FinTech leader and payments architect with 20+ years building card infrastructure, mobile money platforms, and digital transformation systems across Africa. Currently CTO at TechMasters Zambia.',
  avatar: '/images/portrait-office-2.jpg',
  href: '/about',
};

export function bundledArticleToBlocks(article: BundledArticle): ArticleBlock[] {
  const bodyBlocks = markdownToBlocks(article.bodyMd);
  const quizBlock: ArticleBlock | null =
    article.quiz && article.quiz.length > 0
      ? { type: 'quiz', questions: article.quiz }
      : null;
  // Order: prose first, then quiz at the tail, then the author card last so
  // the page renders [content] → [quiz] → [author bio] like v1.
  return [
    ...bodyBlocks,
    ...(quizBlock ? [quizBlock] : []),
    DEFAULT_AUTHOR_BLOCK,
  ];
}
